<template>
	<section class="column is-4-tablet is-3-desktop is-3-widescreen is-2-fullhd product-filters">
		<div class="card">
			<div class="card-content has-text-centered">
				<b-button type="is-primary" icon-left="sync-alt" outlined expanded @click="_submitFilters">
					{{ $t('Refresh data') }}
				</b-button>
				<span class="control-label">{{ $t('Number of results') }}:<span v-if="_resultCount !== null"> {{ _allCount }} / {{ _resultCount }}</span></span>
			</div>
		</div>
		<section>
			<b-collapse class="panel" aria-id="searchfilters" :open.sync="isOpen">
				<div
					slot="trigger"
					slot-scope="props"
					class="card-header is-hidden-tablet"
					role="button"
					aria-controls="searchfilters"
				>
					<span class="card-header-title">
						{{ $t('Filters') }}
					</span>
					<a class="card-header-icon">
						<b-icon size="is-small" :icon="props.open ? 'chevron-up' : 'chevron-down'"></b-icon>
					</a>
				</div>
				<div class="card-content">
					<b-field type="is-primary">
						<b-input
							value="_filters.keyword"
							v-model="_filters.keyword"
							type="search"
							icon="search"
							v-on:keyup.enter.native="getInputValue()"
							expanded
						/>
						<p class="control">
							<b-button type="is-primary" outlined v-on:click.prevent="getInputValue()">{{ $t('Search') }}</b-button>
						</p>
					</b-field>
					<b-field>
						<b-switch
							@input="_submitFilters"
							v-model="_filters.isFinishedProductsSwitched"
							v-on:click.native="changeUploadedSwitchToFalse"
						>
							{{ $t('Expired products') }}
						</b-switch>
					</b-field>
					<b-field v-if="$store.getters.loggedIn == true">
						<b-switch
							@input="_submitFilters"
							v-model="_filters.isBiddedProductsSwitched"
							v-on:click.native="changeUploadedSwitchToFalse"
							>{{ $t('Bidded products') }}</b-switch
						>
					</b-field>
					<b-field v-if="$store.getters.loggedIn == true">
						<b-switch
							@input="_submitFilters"
							v-model="_filters.isFavoritesProductsSwitched"
							v-on:click.native="changeUploadedSwitchToFalse"
							>{{ $t('Favorite products') }}</b-switch
						>
					</b-field>
					<b-field v-if="$store.getters.loggedIn == true">
						<b-switch 
							@input="_submitFiltersUserProd" 
							v-model="_filters.isUploadedProductsSwitched"
							v-on:click.native="uploadedSwitchChanged"
							>{{
							$t('Users products')
						}}</b-switch>
					</b-field>
					<b-field :label="$t('Date filter')" label-for="datefilter">
						<b-slider
							v-model="_params.dates"
							@change="changeSlider"
							@input="changeSlider_"
							type="is-primary"
							:min="_dates[0]"
							:max="_dates[1]"
							:aria-label="[$t('Year from'), $t('Year to')]"
						>
						</b-slider>
					</b-field>
					<b-field grouped>
						<b-field expanded>
							<b-numberinput
								:controls="false"
								validation-message="&nbsp;"
								:min="_dates[0] - 1"
								:max="_dates[1] + 1"
								:value="$data._tmp_dates[0]"
								@input="setDateValueMin"
								v-on:keyup.native.enter="getDateValueMin"
								ref="dateMin"
								id="datefilter"
							>
							</b-numberinput>
						</b-field>
						<b-field expanded>
							<b-numberinput
								:controls="false"
								validation-message="&nbsp;"
								:min="_dates[0] - 1"
								:max="_dates[1] + 1"
								:value="$data._tmp_dates[1]"
								@input="setDateValueMax"
								v-on:keyup.native.enter="getDateValueMax"
								ref="dateMax"
								id="datefilter"
							>
							</b-numberinput>
						</b-field>
					</b-field>
					<b-field :label="$tc('continent', 2) + ' / ' + $tc('country', 2)" label-for="countries">
						<b-taginput
							v-model="_params.countries"
							:data="_filteredCountries"
							autocomplete
							:field="$i18n.locale == 'hu' ? 'name' : 'languages.en'"
							icon="globe"
							placeholder
							@typing="_getFilteredCountries"
							@input="_submitFilters"
							id="countries"
						>
							<template slot-scope="props">{{
								$i18n.locale == 'hu' ? props.option.name : props.option.languages.en
							}}</template>
							<template slot="empty">{{ $t('No results…') }}</template>
						</b-taginput>
					</b-field>
					<b-field :label="$tc('region', 2) + ' / ' + $tc('city', 2)" label-for="cities">
						<b-taginput
							v-model="_params.cities"
							:data="_cities"
							autocomplete
							:field="$i18n.locale == 'hu' ? 'name' : 'languages.en'"
							icon="globe"
							:loading="_isFetching"
							@typing="_getCities"
							@input="_submitFilters"
							id="cities"
						>
							<template slot-scope="props">{{
								$i18n.locale == 'hu' ? props.option.name : props.option.languages.en
							}}</template>
							<template slot="empty">{{ $t('No results…') }}</template>
						</b-taginput>
					</b-field>
					<b-field :label="$tc('tag', 2)" label-for="tags">
						<b-taginput
							v-model="_params.tags"
							:data="_filteredTags"
							autocomplete
							:field="$i18n.locale == 'hu' ? 'name' : 'languages.en'"
							icon="tags"
							placeholder
							@typing="_getFilteredTags"
							@input="_submitFilters"
							id="tags"
						>
							<template slot-scope="props">{{
								$i18n.locale == 'hu' ? props.option.name : props.option.languages.en
							}}</template>
							<template slot="empty">{{ $t('No results…') }}</template>
						</b-taginput>
					</b-field>
					<b-button type="is-danger" icon-left="eraser" expanded outlined @click="_clearsearch">{{
						$t('Reset filter')
					}}</b-button>
				</div>
			</b-collapse>
		</section>
	</section>
</template>
<script>
export default {
	name: 'ProductFilters',

	props: [
		'_submitFilters',
		'_submitFiltersUserProd',
		'_getByCategory',
		'_getFilteredTags',
		'_getFilteredCountries',
		'_getCities',
		'_filters',
		'_filterByCategory',
		'_filteredCountries',
		'_filteredTags',
		'_categories',
		'_params',
		'_isKeywordActive',
		'_clearsearch',
		'_dates',
		'_continents',
		'_counties',
		'_countries',
		'_cities',
		'_tags',
		'_selected',
		'_isFetching',
		'_getCategories',
		'_resultCount',
		'_allCount',
	],
	data() {
		return {
			// eslint-disable-next-line vue/no-reserved-keys
			_tmp_dates: [this._params.dates[0], this._params.dates[1]],
			isOpen: true,
		}
	},
	mounted() {
		var _this = this
		this.$root.$on('getDates', (dates) => {
			_this.$data._tmp_dates[0] = dates[0]
			_this.$data._tmp_dates[1] = dates[1]
		}),
		this.$nextTick(function() {
			window.addEventListener('resize', this.isWide)
		})
	},
	methods: {
		clear() {
			this.$root.$emit('getDates')
			this._clearsearch()
		},
		changeSlider(val) {
			this.$data._tmp_dates = val
			//setTimeout(this._submitFilters, 1000)
			this._submitFilters(false, { dates: val })
		},
		changeSlider_(val) {
			this.$data._tmp_dates = val
			//   this._submitFilters();
		},
		uploadedSwitchChanged(){

		},
		changeUploadedSwitchToFalse() {
			this._filters.isUploadedProductsSwitched = false
			/*if(_filters.isUploadedProductsSwitched){
        this._filters.isFinishedProductsSwitched = true;
        this._filters.isBiddedProductsSwitched = false;
        this._filters.isFavoritesProductsSwitched = false;
      }*/
		},
		clearKeyword() {
			if (this._filters.keyword.length > 2) {
				this._filters.keyword = ''
				this._submitFilters()
			}
		},
		isWide() {
			const vw = Math.max(document.documentElement.clientWidth || 0, window.innerWidth || 0)
			if (vw > 768) this.isOpen=true
		},
		getInputValue() {
			this.$router.replace({ name: "Products", query: {k:this._filters.keyword} });
			this._submitFilters()
		},
		getDateValueMin() {
			this._params.dates[0] = this.$data._tmp_dates[0]
			this._submitFilters()
		},
		getDateValueMax() {
			this._params.dates[1] = this.$data._tmp_dates[1]
			this._submitFilters()
		},
		setDateValueMin(val) {
			if (val >= this._dates[0] && val <= this._dates[1]) {
				const m = this._params.dates[1]
				if (val > m) {
					this._params.dates = [m, val]
				} else {
					this._params.dates = [val, m]
				}
			} else {
				this.$refs.dateMin.checkHtml5Validity()
			}
		},
		setDateValueMax(val) {
			if (val >= this._dates[0] && val <= this._dates[1]) {
				const m = this._params.dates[0]
				if (val < m) {
					this._params.dates = [val, m]
				} else {
					this._params.dates = [m, val]
				}
			} else {
				this.$refs.dateMax.checkHtml5Validity()
			}
		},
	},
	created() {
		this.min = 0
		this.max = 250
		this.bgStyle = {
			backgroundColor: '#fff',
			boxShadow: 'inset 0.5px 0.5px 3px 1px rgba(0,0,0,.36)',
		}
		this.tooltipStyle = {
			backgroundColor: '#666',
			borderColor: '#666',
		}
		this.processStyle = {
			backgroundColor: '#999',
		}
	},
}
</script>
<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
.card-header-title {
	padding: 0.75rem 0.75rem 0.75rem 1.5rem;
}
.card-header-icon {
	padding: 0.75rem 1.5rem 0.75rem 0.75rem;
}
* >>> .label {
	font-weight: normal;
	margin-bottom: 0;
}
</style>
